import { Outlet, useNavigate, useParams } from "react-router-dom";
import Button from "../../componentLibrary/Button";
import { usePermissions } from "../../contexts/PermissionContext";

const ToolboxLayout = () => {
  const { topicId } = useParams<{ topicId: string }>();
  const navigate = useNavigate();
  const { canReadContent } = usePermissions();

  const showAdminLink = Boolean(topicId && canReadContent);

  return (
    <div className="flex flex-col w-full mx-auto px-4 xl:px-16 py-6 min-h-screen">
      {showAdminLink ? (
        <div className="flex justify-end pb-3 mb-1 border-b border-gray-200">
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={() => navigate(`/admin/toolboxes/${topicId}`)}
          >
            Go to toolbox manager
          </Button>
        </div>
      ) : null}
      <Outlet />
    </div>
  );
};

export default ToolboxLayout;
